export default __webpack_public_path__ + "static/media/chevron-left-circle.4ca7f704.svg";